export default "__VITE_ASSET__B8sVD47I__"